import { useEffect } from 'react'

import { useTranslation } from 'react-i18n-lite'

import { useNavigate } from 'react-router-dom'

import { StandardUniselection } from '@yes.technology/react-toolkit'

import locales, { defaultLanguage } from 'infrastructure/i18n'

import { useQuery } from 'shared/utils/url/useQuery'

type SelectionOption = {
  id: string
  value: string
  label?: string
}

const Language = () => {
  const { t, language, setLanguage } = useTranslation()

  const navigate = useNavigate()

  const handleChangeLanguage = (selected: SelectionOption) => {
    const newLanguage = selected?.id || defaultLanguage

    setLanguage(newLanguage)

    navigate('?lang=' + newLanguage)
  }

  const options: SelectionOption[] = Object.keys(locales).map((localeKey) => ({
    id: localeKey,
    value: localeKey,
    label: locales[localeKey]['language-name']
  }))

  const selectedLanguage = options.find((option) => option.id === language)

  return (
    <>
      <SetLang />
      <StandardUniselection
        label={t('language.label')}
        options={options}
        selectedOption={selectedLanguage}
        onSelect={(selected) => {
          handleChangeLanguage(selected as SelectionOption)
        }}
        heightClass='regular'
        required
      />
    </>
  )
}

const SetLang = () => {
  const query = useQuery()

  const lang = query.get('lang')

  const { setLanguage } = useTranslation()

  useEffect(() => {
    if (lang) {
      setLanguage(lang)
    }
  }, [lang, setLanguage])

  return null
}

export default Language
